/* eslint-disable prettier/prettier */
/* eslint-disable */

import React from 'react';

import DiagnosticCardWrapper from '../../DiagnosticCardWrapper';
import { IIndependentDiagnosticInfo } from '../../../../../api/types';
import FormatGrid from 'portfolio3/features/pdf/components/FormatGrid';

import './index.scss';

interface IIndependentDiagnosticListProps {
  diagnostics?: IIndependentDiagnosticInfo[];
}

const IndependentDiagnosticList: React.VFC<IIndependentDiagnosticListProps> = ({ diagnostics }) => {
  const year = (diagnostics && new Date(diagnostics[0].eventDate).getFullYear()) || null;

  return (
    <div className="pdf-independent-diagnostic-list">
      <header className="pdf-independent-diagnostic-list__header">
        <h3 className="pdf-independent-diagnostic-list__title">Пройденные независимые диагностики</h3>
      </header>
      <div className="pdf-independent-diagnostic-list__items">
        <FormatGrid>
          {diagnostics?.map((diagnostic, index) => (
            <DiagnosticCardWrapper diagnostic={diagnostic} />
          ))}
        </FormatGrid>
      </div>
    </div>
  );
};

export default IndependentDiagnosticList;
